<template>

  <div>
    <v-alert text color="green" :value="!alarms.length" type="success">
      {{ $t('map.sidebar.no-alarms') }}
    </v-alert>

    <alarms-panel v-if="alarms.length" :items="alarms" @destroyed="refresh()" @map="show($event)"></alarms-panel>
  </div>

</template>

<script>

  import Vue from 'vue'
  import { Component, Prop } from 'vue-property-decorator'
  import { Action, namespace } from 'vuex-class'
  import AlarmsPanel from '../../alarms/alarms-panel.vue'
  import { MapService } from '../services/map.service.es6'

  const mapModule = namespace('map')

  @Component({
    components: {
      alarmsPanel: AlarmsPanel
    }
  })
  export default class SidebarAlarms extends Vue {
    service = MapService

    /// PROPERTIES

    @Prop({ default: [] }) alarms

    @Action('getItems') getItems

    @mapModule.Action('select') select

    /// GETTERS

    /// METHODS

    async refresh () {
      await this.getItems({ model: { name: 'alarms' } })
    }

    show (assetId) {
      const element = this.service.getElementByAsset(assetId)

      if (!element) {
        this.$toast(this.$t('map.sidebar.no-elements-found'))
      } else {
        this.select(element)
      }
    }
  }

</script>


<style lang="scss" scoped>

  .v-alert {
    border-radius: 0;
  }

</style>
